module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_troms_og_finnmark_pos.220b697a.pdf";